module.exports = __webpack_public_path__ + "static/img/2.6dbf174.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/eng/2.png
// module id = ZZes
// module chunks = 0